module.exports = __webpack_public_path__ + "img/logo.056d16d3.svg";